import { format, type Locale } from 'date-fns';

/**
 * Formats a date using date-fns with the provided locale
 * @param date - The date to format
 * @param formatString - The format string (default: 'PPPp')
 * @param locale - The date-fns locale object
 * @returns Formatted date string or null if locale is not available or formatting fails
 */
export default function formatDate(date: Date, formatString: string = 'PPPp', locale?: Locale): string | null {
  if (!locale) return null;

  try {
    return format(date, formatString, { locale });
  } catch (_error: unknown) {
    return null;
  }
}
